module.exports = __webpack_public_path__ + "static/media/3.e42faeb0.jpg";